import React from 'react';

const Home = () => (
  <div className="content-container">
    <h2>Welcome to our page!</h2>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Sapiente accusantium blanditiis non qui necessitatibus est
      sunt assumenda a eiusdoloremque dignissimos, mollitia sit,
      laudantium officiis aspernatur soluta exercitationem molestias
      cumque?
      Sint aut molestias voluptas mollitia quo! Soluta, illo nesciunt!
      Minima exercitationem officiis earum aliquid
      doloribus cum odit perspiciatis delectus animi id blanditiis,
      itaque, et dolorum quasi quod nihil autem reprehenderit?
    </p>
    <p>
      Lorem ipsum dolor sit amet consectetur adipisicing elit.
      Atque, nisi reiciendis.
      Obcaecati perferendis necessitatibus inventore numquam
      id provident sint alias omnis
      voluptatem molestiae doloribus culpa, dolorem optio cum,
      aut minima!
      Ipsum, porro assumenda suscipit eaque accusantium, odio
      esse itaque similique
      quam expedita corporis laborum dolore nam est eligendi
      labore qui quod voluptas,
      debitis nobis quisquam quos error distinctio nostrum? Sunt.
    </p>
  </div>
);

export default Home;
